import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import ReactGA from "react-ga4";
import { RouterProvider } from "react-router-dom";

import { router } from "./router";

// 初始化 Google Analytics
ReactGA.initialize("G-50NMMXXZD0");

// 获取根节点
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = ReactDOM.createRoot(document.querySelector("#root")!);

// 渲染应用
root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);

// 在浏览器空闲时预加载其他路由组件
if ("requestIdleCallback" in window) {
  window.requestIdleCallback(() => {
    // 预加载常用组件
    void import("./pages/home/page");
    void import("./pages/dashboard/resumes/page");
    void import("./pages/auth/login/page");
  });

  // 延迟加载不太紧急的资源
  setTimeout(() => {
    window.requestIdleCallback(() => {
      void import("./pages/pricing/page");
      void import("./pages/dashboard/settings/page");
    });
  }, 3000);
}
